<div class="main-banner">
  <div class="main-banner__content">
    <div class="row">
      <div class="col-lg-8 col-md-12">
        <app-hero-title>
          <span before>{{ 'main_banner_before' | t }}</span>
          <span highlight>{{ 'main_banner_highlight' | t }}</span>
          <span after>{{ 'main_banner_after' | t }}</span>
        </app-hero-title>
      </div>
    </div>

    <app-search></app-search>
  </div>

  <div class="main-banner__background"></div>
</div>
